import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getIsFeatureExist, getMisc } from "../../../apiclients/streamsapi_bridge";
import FeatureWarning from "../editUtils/FeatureWarning";
import PopupLoader from "../../../views/popups/PopupLoader";
const UserCallRecording = ({
  register,
  setValue,
  accCallRecord,
  watch,
  getValues,
  recordEnabledFlag,
  setIsloading,
  useragent
}) => {
  const { t, i18n } = useTranslation();
  const [CallRecording, setCallRecording] = useState(false);
  const [recordList, setRecordList] = useState([]);
  const [accCallRecording, setaccCallRecording] = useState("");
  const [hideotherrecording, setHideOtherRecording] = useState(false);
  const [editRecordWarning, seteditRecordWarning] = useState(false);
  const recordWarningToggle = () => seteditRecordWarning(!editRecordWarning);
  const [warningMessage, setwarningMessage] = useState("");

  useEffect(() => {
    async function fetchData() {
      let accessRecordList = [];
      let apiResponse = await getMisc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        { misc: ["call_rec"] }
      );
      if (apiResponse.status === 200) {
        accessRecordList = await apiResponse.json();
        setRecordList(
          accessRecordList.misc.call_rec.users_permit_access_call_rec
        );
        //alert(JSON.stringify(groupList));
        // setSourceGroups(groupList);
      } else {
        // Unable to process the request case.
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    if (accCallRecord) {
      setaccCallRecording(accCallRecord);
    }
  }, [accCallRecord]);

  // useEffect(() => {
  //   //alert(getValues('call_rec.enable_call_rec'));
  //   if (getValues("call_rec.enable_call_rec")) {
  //     setCallRecording(true);
  //   }
  // }, [getValues("call_rec.enable_call_rec")]);

  // useEffect(() => {
  //  // alert(getValues("call_rec.record_all_calls"));
  //   if (getValues("call_rec.record_all_calls")) {
  //     setHideOtherRecording(true);
  //   }
  // }, [getValues("call_rec.record_all_calls")]);

  async function handleIsAddonExist() {
    setIsloading(true);
    // 73 fax addon id
    let saverep = await getIsFeatureExist(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      useragent,
      77
    );
    setValue("call_rec.enable_call_rec", true, {
      shouldDirty: true,
    });
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    console.log(`reponse of getIsFeatureExist :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(
      "response of getIsFeatureExist :::" + JSON.stringify(saverepeMsg)
    );

    if (saverepeMsg.status && saverepeMsg.status == "success") {
      const errorMessage = saverepeMsg.message;
      if (errorMessage && errorMessage !== "") {
        setwarningMessage(saverepeMsg.message);
        recordWarningToggle();
      }
    }
  }

  const handleOk = (e) => {
    e?.preventDefault();
    setValue("call_rec.enable_call_rec", false, {
      shouldDirty: true,
    });
    recordWarningToggle();
  };

  const handleToggleChange = () => {
    const toggleid = document.getElementById("toggleCheckbox");
    setValue("call_rec.enable_call_rec", toggleid.checked ? true : false, {
      shouldDirty: true,
    });
  };
  return (
    <>
      <div className="general-settings" id="CallRecording">
        {t("CallRecording")}
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">{t("EnCallRecording")}</div>
        <div className="phoneselect">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              id="toggleCheckbox"
              checked={watch("call_rec.enable_call_rec")}
              onChange={(e) => {
                const isChecked = e.target.checked;
                if (isChecked && recordEnabledFlag !== isChecked) {
                  handleIsAddonExist();
                } else {
                  setValue("call_rec.enable_call_rec", isChecked, {
                    shouldDirty: true,
                  });
                  
                }
                if (isChecked) {
                    setValue("call_rec.allow_user_edit_call_rec", true, {
                      shouldDirty: true,
                    });
                  } else {
                    setValue("call_rec.allow_user_edit_call_rec", false, {
                      shouldDirty: true,
                    });
                }
              }}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      {watch("call_rec.enable_call_rec") && (
        <div>
          <div className="add-numbermain">
            <div className="tel-numbers">{t("Allow User to Edit Call Recording Settings")}</div>
            <div className="phoneselect">
              <label className="switch">
                <input
                  className="form-control"
                  {...register("call_rec.allow_user_edit_call_rec")}
                  type="checkbox"
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
          <div className="add-numbermain">
            <div className="tel-numbers">{t("RecAllCalls")}</div>
            <div className="phoneselect">
              <label className="switch">
                <input
                  className="form-control"
                  checked={watch("call_rec.record_all_calls")}
                  type="checkbox"
                  onChange={() => {
                    // setHideOtherRecording((obj) => !obj);
                    const newValue = !getValues("call_rec.record_all_calls"); // Toggle the value
                    setValue("call_rec.record_all_calls", newValue, {
                      shouldDirty: true,
                    });
                  }}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
          {!watch("call_rec.record_all_calls") && (
            <>
              <div className="add-numbermain">
                <div className="tel-numbers">{t("RecOutboundcalls")}</div>
                <div className="phoneselect">
                  <label className="switch">
                    <input
                      className="form-control"
                      {...register("call_rec.record_outbound_calls")}
                      type="checkbox"
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
              <div className="add-numbermain">
                <div className="tel-numbers">{t("RecInboundcalls")}</div>
                <div className="phoneselect">
                  <label className="switch">
                    <input
                      className="form-control"
                      {...register("call_rec.record_inbound_calls")}
                      type="checkbox"
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
              <div className="add-numbermain">
                <div className="tel-numbers">{t("RecAllIntCalls")}</div>
                <div className="phoneselect">
                  <label className="switch">
                    <input
                      className="form-control"
                      {...register("call_rec.record_all_int_calls")}
                      type="checkbox"
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </>
          )}
          {/* <div className="add-numbermain">
            <div className="tel-numbers">{t("PlayCallRecbeep")}</div>
            <div className="phoneselect">
              <label className="switch">
                <input
                  className="form-control"
                  {...register("call_rec.play_call_rec_beep")}
                  type="checkbox"
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div> */}
          <div className="add-numbermain">
            <div className="tel-numbers">{t("Userpermcallrec")}</div>
            <div className="phoneselect w-30">
              <select
                className="form-control form-select selectname w-100"
                value={watch("call_rec.users_permit_access_call_rec")}
                name="San Jose"
                onChange={(e) => {
                  e.preventDefault();
                  setaccCallRecording(parseInt(e.target.value));
                  setValue(
                    "call_rec.users_permit_access_call_rec",
                    parseInt(e.target.value),
                    { shouldDirty: true }
                  );
                }}
              >
                {recordList &&
                  Object.entries(recordList).map(([value, key]) => (
                    <option key={key} value={key}>
                      {value}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>
      )}
      {editRecordWarning && (
        <PopupLoader
          size="md"
          className="modal-xl modal-auto"
          title="Alert"
          content={
            <FeatureWarning warningMessage={warningMessage} onOk={handleOk} />
          }
          onShow={seteditRecordWarning}
          onClose={handleOk}
        />
      )}
    </>
  );
};
export default UserCallRecording;
